import React from "react";
import { useEffect, useRef, useState } from "react";
import { flushSync } from "react-dom";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { loginWithGoogle } from "../../api/auth";

const GoogleAuthPage = () => {
    const navigate = useNavigate();
    const { refreshAuth, setIsLoggedIn } = useAuth()
    const called = useRef(false);
    const [logs, setLogs] = useState([]);

    const log = (msg) => {
        console.log(msg);
        setLogs((prev) => [...prev, msg]);
    };

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    useEffect(() => {
      const handleGoogleLogin = async () => {
          log(`[1] URL: ${window.location.href}`);
          log(`[1] code=${code ? code.slice(0,20)+"..." : "없음"} called=${called.current}`);
          if (!code || called.current) {
              log(`[!] 조기 종료 - code없음:${!code} / 이미실행됨:${called.current}`);
              return;
          }
          called.current = true;

          try {
              const apiBase = process.env.REACT_APP_API_BASE_URL;
              log(`[2] API: ${apiBase}`);
              log("[2] loginWithGoogle 호출 중...");
              const data = await Promise.race([
                  loginWithGoogle(code),
                  new Promise((_, reject) => setTimeout(() => reject(new Error("TIMEOUT_15S")), 15000))
              ]);
              log(`[3] 응답: success=${data?.success} status=${data?.status}`);

              if (data?.success && data?.status === "OK") {
                log("[4] OK → navigate");
                flushSync(() => setIsLoggedIn(true));
                navigate("/onboarding", { replace: true });

              } else if (data?.success && data?.status === "REGISTERED") {
                log("[4] REGISTERED → navigate");
                flushSync(() => setIsLoggedIn(true));
                navigate("/onboarding", { replace: true });

              } else {
                log(`[!] 예상치 못한 응답: ${JSON.stringify(data)}`);
                alert("오류 발생: 인증 결과가 올바르지 않습니다.");
                navigate("/auth/login");
              }
          } catch (err) {
              log(`[!] 오류: ${err?.response?.status} / ${JSON.stringify(err?.response?.data)} / ${err?.message}`);
              alert("로그인 중 오류가 발생했습니다.");
              navigate("/auth/login");
          }
      };

      handleGoogleLogin();
    }, [code, navigate, refreshAuth, setIsLoggedIn]);

    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "12px",
          padding: "24px",
        }}
      >
        <span>로딩 중...</span>
        <div style={{ fontSize: "12px", color: "#666", textAlign: "left", whiteSpace: "pre-wrap", maxWidth: "100%" }}>
          {logs.map((l, i) => <div key={i}>{l}</div>)}
        </div>
      </div>
    );
};

export default GoogleAuthPage;
